var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"display-1 font-weight-bold mx-1 mb-3"},[_vm._v("Artwork Board")]),_c('v-btn',{on:{"click":function($event){return _vm.onClick()}}},[_vm._v("Click")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }